export default {
  FAQ_btn: 'Häufig gestellte Fragen',
  privacyPolicy_btn: 'Datenschutzerklärung',
  impressum_btn: 'Impressum',
  contact_us_btn: 'Kontakt',
}



// WEBPACK FOOTER //
// ./src/locale/de-DE/login.js